import request from "superagent";

// Utility function to handle any errors
function handleError(error) {
  let status;
  let message;
  //Error in response
  if (error.response) {
    let res = error.response;
    // Set status
    status = res.status || 500;
    // Message
    switch (res.type) {
      case "application/json":
        message = res.body.message;
        break;
      default:
        message = res.text;
    }
  } else if (error.message) {
    message = error.message;
  }
  // Something else happened!
  else {
    status = 0;
    message = error.message || "Unknown error occurred";
  }
  // Done
  return {
    status: status,
    message: message,
  };
}

// B2B
const admin = {
  config: {
    subOrUnSubscribeNotifi: function (email, resubscribe) {
      var myHeaders = new Headers();
      myHeaders.append("x-api-key", "session");
      var urll =
        "https://api.storecashapp.com/prd/con?s=w&action=unsubscribe_ct_notifs&token=" +
        email +
        "&resubscribe=" +
        resubscribe;
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const res = await request.get(urll).timeout(20000);
          resolve(res.body);
        } catch (err) {
          reject(handleError(err));
        }
      });
    },
  },
};

/**
 * Export
 */
export default {
  admin,
};
